/** Texto de cada intensidade de chuva. */
export const intensityTexts: string[] = ['Fraca', 'Moderada', 'Forte', 'Muito forte'];

/** Cor de cada intensidade de chuva.
 * Fraca: verde
 * Moderada: amarelo
 * Forte: laranja
 * Muito forte: vermelho
 */
export const intensityColors: string[] = ['#339944', '#FFCC00', '#FF8822', '#DD2233'];

/**
 * Valores dos multiplicadores para cada acumulado de chuva.
 * Os valores originais são para o acumulado de 1 h.
 * @see https://pt.wikipedia.org/wiki/Chuva
 * 
 * - Fraca: < 2.5
 * - Moderada < 10
 * - Forte < 50
 * - Muito Forte >= 50.
 * 
 * Para os outros acumulados de chuva, nós apenas multiplicamos esses valores pelo número
 * de horas do acumulado.
 */
export const rainMultipliers: {[key: string]: number} = {
  'indice_pluv': 0.25,
  'quinzemin': 0.25,
  'trintamin': 0.5,
  'umahora': 1,
  'seishoras': 6,
  'dozehoras': 12,
  'vintequatrohoras': 24,
  'quarentaoitohoras': 48,
  'setentaduashoras': 72,
  'noventaseishoras': 96,
  'mes': 24 * 30
};

/**
 * Obtém um valor de intensidade de chuva correspondente ao valor de chuva.
 * @param value valor de chuva cuja intensidade deseja ser obtida.
 * @param multiplier multiplicador do acumulado de chuva. Default 1 para acumulado de 1 h.
 * @param intensities array de valores correspondentes às intensidades Fraca, Moderada, Forte, Muito Forte.
 */
export function getIntensity(
  value: number, 
  multiplier: number = 1, 
  intensities: any[] = intensityTexts) {

  if (value < 2.5 * multiplier) {
    return intensities[0];
  }
  if (value < 10 * multiplier) {
    return intensities[1];
  }
  if (value < 50 * multiplier) {
    return intensities[2];
  }
  return intensities[3];
}